import {
    CoreConfig,
    QuotientTSSAppConfig,
    SSOConfig
} from '../../server/configs/includes/config.types';

export enum ConfigEnvironments {
    DEV = 'dev',
    QAI = 'qai',
    PROD = 'prod',
    PDN = 'pdn'
}

export interface AppConfig {
    apps: QuotientTSSAppConfig['apps'];
    core: CoreConfig;
    sso: SSOConfig;
    version: string;
    environment: ConfigEnvironments;
}

export enum AnalyticsTag {
    PDN = 'G-J73RGWEMGZ',
    PROD = 'G-HD9LK91M6G'
}

/**
 * Ensure event names are unique and not the same as GA's default event names.
 */
export enum AnalyticsEvent {
    UserLogin = 'user_login',
    NavigatedPage = 'navigated_page',
    ButtonClick = 'button_click'
}

export enum RoutePageName {
    Auth = '/auth',
    ShopperReview = '/home/search',
    FraudReview = '/home/on-hold-accounts',
    TransactionReview = '/home/transaction-review',
    OfferReviewDetails = '/home/offer-review/details',
    OfferReview = '/home/offer-review',
    PaymentReview = '/home/payment-review',
    AdminAgentActivity = '/home/admin/agent-activity',
    AdminAuditTrail = '/home/admin/audit-trail',
    Admin = '/home/admin',
    Info = '/info',
    TransactionDetails = '/transactions/details',
    Transactions = '/transactions',
    OfferDetails = '/offers/details',
    Offers = '/offers',
    Payments = '/payments',
    ShopperDetails = '/shopper-details',
    ConsolidatedTransactions = '/shopper-details/all-partners/transactions/consolidated-transactions'
}

/**
 * Order of keys below is important as URL checks for GA tracking follows the same order.
 * For example, /offers/details should be checked before /offers to avoid false positives.
 * So Offer Details should come before Offers.
 */
export const RoutePageNameMap: { [key in RoutePageName]: string } = {
    [RoutePageName.Auth]: 'Authentication Page',
    [RoutePageName.ShopperReview]: 'Shopper Review Page',
    [RoutePageName.FraudReview]: 'Fraud Review Page',
    [RoutePageName.TransactionReview]: 'Transaction Review Page',
    [RoutePageName.OfferReviewDetails]: 'Offer Review Details Page',
    [RoutePageName.OfferReview]: 'Offer Review Page',
    [RoutePageName.PaymentReview]: 'Payment Review Page',
    [RoutePageName.AdminAgentActivity]: 'Admin Agent Activity Page',
    [RoutePageName.AdminAuditTrail]: 'Admin Audit Trail Page',
    [RoutePageName.Admin]: 'Admin Page',
    [RoutePageName.Info]: 'Shopper Info Page',
    [RoutePageName.TransactionDetails]: 'Transaction Details Page',
    [RoutePageName.Transactions]: 'Transactions List Page',
    [RoutePageName.OfferDetails]: 'Offer Details Page',
    [RoutePageName.Offers]: 'Offers List Page',
    [RoutePageName.Payments]: 'Payments Page',
    [RoutePageName.ShopperDetails]: 'Shopper Details Page',
    [RoutePageName.ConsolidatedTransactions]:
        'Consolidated Transactions (for all partners) Page'
};
